const Form090EN = {
    stepNames: {
        importantNotes: "Important Notes",
        applicationInformation: "Application Information",
        confirmation: "Confirmation",
    },

    importantNotesContent: {
        title: "Note",
        p1: "Please read the Personal Information Collection Statement carefully before completing this form.",
        declarationTitle: "Statement",
        declarationList: [
            "The Education Bureau will use the personal data provided in this form for processing matters relating to the nominations of teacher members for the Committees on Key Learning Area and Functional Committees of the Curriculum Development Council (CDC). ",
            "The provision of personal data is obligatory. Failure to provide the required personal data may affect the selection process and outcome. ",
            "You have the right to request access to and correction of the personal data held by EDB. Enquiries concerning the personal data collected by means of this form should be addressed to the CDC Secretariat. ",
        ],
        declarationP2:
            "2.	The provision of personal data by means of this form is obligatory. Failure to provide these data may affect the selection process and outcome. ",
        declarationP3:
            "3.	You have a right to request access to and correction of the personal data as provided for the Personal Data (Privacy Ordinance). Enquiries concerning the personal data collected by means of this form, including making access to and correction of personal data, should be addressed to the CDC Secretariat.",
    },
    label: {
        sectionA: {
            headerTitle: "Section A (To be completed by the Teacher Nominee)",
            part1TitleBefore: "1 Committee to serve on",
            part1TitleAfter:
                " (Please put a ‘✓’ in the appropriate box (You may tick more than one box))",
            part2Title: "2 Personal Particulars",
            englishSurname: "Name in English (HKID) (Surname)",
            englishOtherName: "Name in English (HKID) (Other names)",
            chineseName: "Name in Chinese (HKID)",
            title: "Title",
            otherTitle: "(pls specify)",
            schoolName: "School Name",
            telNo: "Personal Contact Tel No. ",
            email: "E-mail Address",
            part3Title:
                "3 Academic/Professional qualifications obtained (in chronological order)",
            collegeName: "University/College",
            qualification: "Qualification/Title",
            obtainedYear: "Year Obtained",
            majorSubject: "Major Subject",
            otherSubject: "Other Subject",
            beforePart4TitleBoldText: "Please provide details for",
            part4TitleBoldText:
                " the past 10 years (2012/13 - 2022/23 school years)",
            afterPart4TitleBoldText: "",
            part4ATitle: "4a Teaching experience (in chronological order)",
            schoolYearFromPart4A: "School Year (From)",
            schoolYearToPart4A: "School Year (To)",
            present: "Present",
            schoolNamePart4A: "School Name",
            subjectPart4A: "Subject(s)",
            levelPart4A: "Level(s)",
            part4bTitle: "4b Other major responsibilities in school",
            schoolYearFromPart4B: "School Year (From)",
            schoolYearToPart4B: "School Year (To)",
            subjectPanel:
                "Subject Panel/Functional Committee/Others (e.g. Subject Panel, Discipline Committee, Academic Committee)",
            positionPart4B:
                "Position Held (e.g. Panel Head, Discipline Master, Prefect of Studies)",
            part5Title:
                "5 Experience in professional organisations related to curriculum development (e.g. work related to the CDC and the HKEAA, experience in professional associations)",
            schoolYearFromPart5: "School Year (From)",
            schoolYearToPart5: "School Year (To)",
            committeePart5:
                "Committee/Association (e.g. Curriculum Development Council Committee, HKEAA Subject Committee)",
            positionPart5:
                "Position Held (e.g. Chairperson, Secretary, Member)",
            part6Title:
                "6 Other professional experience related to curriculum development (e.g. teacher training, production of learning & teaching reference materials, research/academic publications/co-ordination of school-based curriculum development)",
            schoolYearFromPart6: "School Year (From)",
            schoolYearToPart6: "School Year (To)",
            descriptionPart6:
                "Title/Description (e.g. Seminar, Workshop, Seed project, Action research)",
            positionPart6: "Position Held (e.g. Speaker, Co-ordinator, Author)",
        },
        sectionB: {
            headerTitle: "Section B (To be completed by School Head)",
            recommendation: "Recommendation (optional)",
            conditionConfirm:
                "In nominating the above-named teacher to serve on the Committee of the Curriculum Development Council, I certify that, to the best of my knowledge, the information provided in Section A and Section B is correct. I understand that Committee meetings may be held in the morning or afternoon on school days, and I agree to release him/her as far as practicable to attend the meetings. (Please put a ✓ in the box if you agree)",
            principalEnglishName: "Name of Principal (English)",
            principalChineseName: "Name of Principal (Chinese)",
            title: "Title",
            otherTitle: "(pls specify)",
            email: "E-mail Address",
        },
    },
    titleOptions: {
        Mr: "Mr.",
        Ms: "Ms.",
        Miss: "Miss",
        Other: "Other",
    },

    committeesOptions: [
        {
            title: "Chinese Language Education",
            subTitle: "KLA Committees",
        },
        {
            title: "English Language Education",
            subTitle: "KLA Committees",
        },
        { title: "Mathematics Education", subTitle: "KLA Committees" },
        {
            title: "Personal, Social & Humanities Education",
            subTitle: "KLA Committees",
        },
        { title: "Science Education", subTitle: "KLA Committees" },
        { title: "Technology Education", subTitle: "KLA Committees" },
        { title: "Arts Education", subTitle: "KLA Committees" },
        { title: "Physical Education", subTitle: "KLA Committees" },
        {
            title: "Early Childhood Education",
            subTitle: "Functional Committees",
        },
        {
            title: "Special Educational Needs",
            subTitle: "Functional Committees",
        },
        { title: "Gifted Education", subTitle: "Functional Committees" },
        {
            title: "Learning Resources & Support Services",
            subTitle: "Functional Committees",
        },
        { title: "Applied Learning", subTitle: "Functional Committees" },
    ],

    errorMsg: {
        afterThisYear: "Please select a year on/after {{targetYear}}",
        beforeThisYear: "Please select a year on/before {{targetYear}}",
        suitableLanguage: "Please input a {{label}} in suitable language",
        subjectPanel: "Subject Panel/Functional Committee/Others",
        descriptionPart6: "Title/Description",
        positionPart: "Position Held",
        committeePart5: "Committee/Association",
        chronological: "Please select a year on/after {{targetYear}}",
        subjectRequired: "Please fill in the corresponding subject",
        yearBefore: "Please select a year before this year",
    },
};
export default Form090EN;
